import { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { Helmet } from "react-helmet-async";

const SeoHelmet = () => {
  const location = useLocation();

  const [description, setDescription] = useState(
    "歐悅金融科技提供靈活的貸款服務，正規合法輕鬆借！歐悅金融科技持續擴展學生貸、機車貸款借錢、手機貸款借錢、勞保貸款借錢、無勞保貸款借錢、保單質押、不動產二胎等多項分期付款服務，致力於成為台灣最便利多元的數位金融第一品牌。"
  );
  useEffect(() => {
    if (location.pathname.includes("student")) {
      setDescription(
        "歐悅金融科技提供靈活的學生貸款服務，正規合法輕鬆借！申辦2-10萬的學生貸。享受即時線上申請與審核，且還款期限最長可達36期！歐悅金融科技持續擴展機車貸款借錢、手機貸款借錢、勞保貸款借錢、無勞保貸款借錢、保單質押、不動產二胎等多項分期付款服務，致力於成為台灣最便利多元的數位金融第一品牌。"
      );
    } else if (location.pathname.includes("phone")) {
      setDescription(
        "歐悅金融科技提供靈活的手機貸款服務，只要您自有手機，不留機也能輕鬆借！申辦3-12萬的靈活手機貸，享受即時線上申請與審核，且還款期限最長可達36期！歐悅金融科技持續擴展機車貸款借錢、手機貸款借錢、勞保貸款借錢、無勞保貸款借錢、保單質押、不動產二胎等多項分期付款服務，致力於成為台灣最便利多元的數位金融第一品牌。"
      );
    } else if (location.pathname.includes("labor-insure")) {
      setDescription(
        "歐悅金融科技提供靈活的勞保貸款服務，無需抵押也能輕鬆借！申辦最高20倍投保金額的勞保貸，享受即時線上申請與審核，且還款期限最長可達36期！歐悅金融科技持續擴展機車貸款借錢、手機貸款借錢、勞保貸款借錢、無勞保貸款借錢、保單質押、不動產二胎等多項分期付款服務，致力於成為台灣最便利多元的數位金融第一品牌。"
      );
    } else if (location.pathname.includes("labor-relief")) {
      setDescription(
        "歐悅金融科技提供靈活的無勞保貸款服務，無薪轉也能輕鬆借款！申辦3-10萬的無勞保貸，享受即時線上申請與審核，且還款期限最長可達36期！歐悅金融科技持續擴展機車貸款借錢、手機貸款借錢、勞保貸款借錢、無勞保貸款借錢、保單質押、不動產二胎等多項分期付款服務，致力於成為台灣最便利多元的數位金融第一品牌。"
      );
    } else if (location.pathname.includes("policy")) {
      setDescription(
        "歐悅金融科技提供靈活的保單質押服務，無需其他抵押也能輕鬆借！申辦最高保單價值100%的保單質押，享受即時線上申請與審核，且還款期限最長可達36期！歐悅金融科技持續擴展機車貸款借錢、手機貸款借錢、勞保貸款借錢、無勞保貸款借錢、保單質押、不動產二胎等多項分期付款服務，致力於成為台灣最便利多元的數位金融第一品牌。"
      );
    } else if (location.pathname.includes("two-wheel")) {
      setDescription(
        "歐悅金融科技提供靈活的機車原融服務，無貸款機車便能輕鬆借！申辦10-45萬的機車原融。享受即時線上申請與審核，且還款期限最長可達36期！歐悅金融科技持續擴展機車貸款借錢、手機貸款借錢、勞保貸款借錢、無勞保貸款借錢、保單質押、不動產二胎等多項分期付款服務，致力於成為台灣最便利多元的數位金融第一品牌。"
      );
    } else if (location.pathname.includes("mortgage")) {
      setDescription(
        "歐悅金融科技提供靈活的不動產二胎服務，無需其他抵押就能輕鬆借！申辦最高市價110%的不動產二胎，享受即時線上申請與審核，且還款期限最長可達10年(120期)！歐悅金融科技持續擴展機車貸款借錢、手機貸款借錢、勞保貸款借錢、無勞保貸款借錢、保單質押、不動產二胎等多項分期付款服務，致力於成為台灣最便利多元的數位金融第一品牌。"
      );
    } else {
      setDescription(
        "歐悅金融科技提供靈活的貸款服務，正規合法輕鬆借！歐悅金融科技持續擴展學生貸、機車貸款借錢、手機貸款借錢、勞保貸款借錢、無勞保貸款借錢、保單質押、不動產二胎等多項分期付款服務，致力於成為台灣最便利多元的數位金融第一品牌。"
      );
    }
  }, [location]);

  return (
    <>
      <Helmet key={Date.now()}>
        <meta name="description" content={description} />
        <meta property="og:description" content={description} />
        <link
          rel="canonical"
          href={`${window.location.origin}${location.pathname}`}
          data-rh="true"
        />
        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=AW-10861009790"
        ></script>
        <script>
          {` window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }
      gtag("js", new Date());
      gtag("config", "AW-10861009790");`}
        </script>
        <script>
          {`  window.addEventListener("load", function(event) {
        document.querySelectorAll('[href*="tel:"]').forEach(function(e) {
          e.addEventListener("click", function() {
            gtag("event", "conversion", {
              send_to: "AW-10861009790/duhgCP6I38MZEP6297oo",
            });
          });
        });
      });`}
        </script>
        <script>
          {` window.addEventListener("load", function(event) {
        document
          .querySelectorAll('[href^="https://lin.ee/"]')
          .forEach(function(e) {
            e.addEventListener("click", function() {
              gtag("event", "conversion", {
                send_to: "AW-10861009790/7Ym6CPuI38MZEP6297oo",
              });
            });
          });
      });`}
        </script>
        <script>
          {`      window.addEventListener("load", function(event) {
        document
          .querySelector(
            "#root > div > div > div > div.fixed.right-\\[11px\\].bottom-\\[205px\\].w-\\[64px\\].h-\\[64px\\].z-20 > button > div"
          )
          .addEventListener("click", function() {
            gtag("event", "conversion", {
              send_to: "AW-10861009790/7Ym6CPuI38MZEP6297oo",
            });
          });
      });`}
        </script>
        <script>
          {` window.addEventListener("load", function(event) {
        if (window.location.href.includes("/received")) {
          gtag("event", "conversion", {
            send_to: "AW-10861009790/K6JKCIGJ38MZEP6297oo",
          });
        }
      });`}
        </script>
      </Helmet>
    </>
  );
};
export default SeoHelmet;
